import { EWidgetSource } from '../../repositories/billing-service-packages-balancer/entities/Purchase/AddRecommendedServicePackageRequest';
import { IMappers, fetchBuyPackage } from '../../repositories/billing-service-packages-balancer/v2/buy-package';
import { IBuyPackageResult } from '../../thunks/runBuyPackageLegacy/afterPurchasingPackage';
import { IBuyPackageParams } from './types';
import { mapResponse200 } from './utils';

export const buyPackage = async (props: IBuyPackageParams): Promise<IBuyPackageResult> => {
  const { httpApi, packageId, autoProlong, polygonIds } = props;

  const widgetSource = props.widgetSource as string as EWidgetSource;

  const parameters = { packageId, autoProlong, polygonIds, widgetSource, needHold: false };

  const mappers: IMappers<IBuyPackageResult> = {
    200: mapResponse200,
  };

  try {
    return (await fetchBuyPackage({ httpApi, mappers, parameters })) as IBuyPackageResult;
  } catch (e) {
    return { isSuccess: false };
  }
};
